<template>
  <div class="lottery-wrapper">
    <b-loading
      :is-full-page="true"
      :active.sync="showLoading"
    >
      <div class="loading-wrap">
        <div class="loading-icon" />
        <div class="loading-text">
          奖励抽取中，请稍后...
        </div>
      </div>
    </b-loading>
    <b-modal
      :active.sync="showModal"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <template v-if="hasAward">
            恭喜您获得了{{ award }}
          </template>
          <template v-else>
            奖励发放失败，请重新领奖
          </template>
        </header>
        <section class="modal-card-body">
          <p>注：</p>
          <p>1.道具奖品系统将自动发放到游戏内</p>
          <p>2.实物奖品后续由工作人员联系领取</p>
        </section>
        <footer class="modal-card-foot">
          <button
            v-if="hasAward"
            class="button is-primary"
            @click="handleClose"
          >
            关闭
          </button>
          <button
            v-if="!hasAward"
            class="button is-primary"
            @click="handleAward"
          >
            重新领奖
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { lottery } from '@/apis/survey';

export default {
  name: 'Lottery',
  props: {
    sid: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      hasAward: false,
      award: '',
      awardTimes: 0,
      showLoading: false,
      showModal: false,
    };
  },

  created() {
    this.$nextTick(() => {
      this.handleAward();
    });
  },

  methods: {
    handleClose() {
      this.showModal = false;
    },
    async handleAward() {
      if (this.awardTimes < 3) {
        this.showLoading = true;
        this.awardTimes += 1;
        try {
          const res = await lottery(this.sid);
          const { data } = res;
          this.showLoading = false;
          this.hasAward = true;
          this.award = data.package_name;
          this.showModal = true;
        } catch (e) {
          const { error } = e;
          this.showLoading = false;
          if (error.code === 10017) {
            this.$buefy.dialog.alert(error.detail);
          } else {
            this.hasAward = false;
            this.showModal = true;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  &-wrap {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    .loading {
      &-icon {
        width: 5em;
        height: 5em;
      }
      &-text {
        margin-top: 10px;
        color: #fff;
      }
    }
  }
}
</style>
